export default {"src":"/_next/static/media/2.412fa510.svg","height":170,"width":304,"blurWidth":0,"blurHeight":0};